import { render, staticRenderFns } from "./HKBankSelect.vue?vue&type=template&id=6944f2f4&scoped=true&"
import script from "./HKBankSelect.vue?vue&type=script&lang=js&"
export * from "./HKBankSelect.vue?vue&type=script&lang=js&"
import style0 from "./HKBankSelect.vue?vue&type=style&index=0&id=6944f2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944f2f4",
  null
  
)

export default component.exports